module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-mask"
  }, [_c('div', {
    staticClass: "tips-wrapper"
  }, [(!_vm.tipsFontWaring) ? _c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.tipsFont))])]) : _vm._e(), _vm._v(" "), (_vm.tipsFontWaring) ? _c('div', {
    staticClass: "tips-font red-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.tipsFont))])]) : _vm._e(), _vm._v(" "), (_vm.btnNum === 1) ? _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-one-btn",
    on: {
      "click": _vm.onConfirmF
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), (_vm.btnNum === 2) ? _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-btn-line",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": _vm.onConfirmS
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), (_vm.btnNum === 3) ? _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-btn-line",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.btnFont[0]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": _vm.onConfirmS
    }
  }, [_vm._v(_vm._s(_vm.btnFont[1]))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-012ea951!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips.vue
// module id = 524
// module chunks = 1